import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import cx from 'classnames';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';
import DropdownCore from 'core/components/Dropdown';
import ShapkaMenuItems from 'core/components/ShapkaMenuItems';
import ThemeSwitch from 'core/components/ThemeSwitch';
import EmptyWrapper from 'core/components/EmptyWrapper';

import styles from './index.styl';


function Dropdown(props) {
  const {
    theme,
    onClose,
    onOpen,
    navRef,
    menuIcon,
    isFirstShapkaForPremium,
    moreMenu,
    currentItem,
  } = props;

  const {
    controls: {
      shapka: {
        ArrowDropdown,
        dropdown: dropdownAtoms,
        dropdown: {
          link: linkAtoms,
          more: moreAtoms,
        },
        subnav,
      },
    },
  } = theme;

  const [mounted, setMounted] = useState(false);
  const [paddingLeft, setPaddingLeft] = useState(0);

  useEffect(() => {
    if (process.env.BROWSER_RUNTIME && navRef.current) {
      setPaddingLeft(navRef.current.offsetLeft + 'px');
    }
    setMounted(true);
  }, [navRef]);

  const dropdown = isFirstShapkaForPremium ? dropdownAtoms.premiumTopic : dropdownAtoms;

  const Wrapper = isFirstShapkaForPremium ? ThemeSwitch : EmptyWrapper;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.dropdown}
          height auto
          color ${theme.colors.primary}
          :global(.dropdown-content)
            box-shadow ${dropdown.boxShadow}
            :global(.desktop) &
              margin-top ${dropdown.marginTop}
    `}</style>
    </scope>
  );

  return (
    <Wrapper name='light'>
      <style jsx>{`
        .${styles.list}
          background ${dropdown.background}

          .${styles._fullwidthDropdown} &
            height ${dropdown.height}

        .${styles.more}
          font ${linkAtoms.font}
          text-transform ${linkAtoms.textTransform}

        .${styles.subnav}
          color ${moreAtoms.idle.color}
          padding ${linkAtoms.padding}
          &:hover
            color ${moreAtoms.hover.color}
            text-decoration ${moreAtoms.hover.decoration}
        `}</style>
      <div
        className={cx(
          styles.navItem,
          subnav === 'right' && styles._navItemAtRight,
          isFirstShapkaForPremium && styles._premium,
          dropdown.fullwidth && styles._fullwidthDropdown
        )}
      >
        <DropdownCore
          className={scope.wrapClassNames(styles.dropdown)}
          showIcon={false}
          anchor=
            {isFirstShapkaForPremium ?
              menuIcon : (
                <div className={styles.subnav}>
                  <div className={styles.more} data-qa='lb-menu-more'>Ещё</div>
                  <ArrowDropdown width='8' height='8' />
                </div>
              )}
          onOpen={onOpen}
          onClose={onClose}
          contentPadding={dropdown.padding}
          contentOpacityDuration='0s'
          closeAfterUrlChanged
          contentBorderRadius={dropdown.borderRadius}
          trigger={dropdown.trigger}
          contentPosition={dropdown.position}
        >
          {mounted && (
            <div
              {...dropdown.fullwidth && { style: { paddingLeft } }}
              className={styles.list}
            >
              <ShapkaMenuItems
                items={moreMenu}
                currentItem={currentItem}
                isFirstShapkaForPremium={isFirstShapkaForPremium}
              />
            </div>
          )}
        </DropdownCore>
      </div>
      <scope.styles />
    </Wrapper>
  );
}

const iconContract = `
  {
    Icon,
    width,
    height,
  }
`;

Dropdown.propTypes = {
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  navRef: PropTypes.object,
  isFirstShapkaForPremium: PropTypes.bool,
  moreMenu: PropTypes.array,
  currentItem: PropTypes.object,
  menuIcon: PropTypes.node,
  /**
   * @ignore
   */
  theme: themePropTypes(`
    {
      colors: {
        content
      },
      controls: {
        shapka: {
          subnav,
          close: ${iconContract},
          burger: ${iconContract},
          link: {
            padding,
            font,
            textTransform,
            idle: {
              color,
            },
          },
          dropdown: {
            background,
            height,
            boxShadow,
            trigger,
            fullwidth,
            padding,
            borderRadius,
            position,
            more: {
              idle: {
                color,
              },
              hover: {
                color,
                decoration,
              }
            }
          }
        }
      }
    }
  `),
};

export default withTheme(withBreakpoint(Dropdown));
